/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import Layout from './src/components/Layout';
import { LocalContextProvider } from './src/context/LocalContext';
import trackEvent from './src/utils/trackEvent';

export const wrapPageElement = ({ element, props }) => <Layout {...props}>{element}</Layout>;

export const wrapRootElement = ({ element }) => (
  <LocalContextProvider>{element}</LocalContextProvider>
);

/**
 * GA4 page views for client-side navigation.
 *
 * The gtag snippet is injected by Netlify and only records the page that was loaded; Gatsby
 * then navigates without full page loads, so without this nothing after the landing page was
 * being counted (September 2026: 1.1 pages per session, two thirds of all views on "/").
 * The initial page view is still sent by the snippet's gtag('config') call, so the first
 * onRouteUpdate (prevLocation null) is skipped. Only path changes count: query-string or
 * hash-only updates are not new pages. GA4's own "page changes based on browser history
 * events" enhanced measurement is not firing on this property; if it is ever switched on,
 * remove this hook to avoid double counting.
 */
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (!prevLocation || location.pathname === prevLocation.pathname) return;

  // Gatsby's Head API writes the new document.title shortly after the route renders; wait
  // two frames so the page view carries the right title.
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      trackEvent('page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title
      });
    });
  });
};
